export default __webpack_public_path__ + "static/media/Peter-Velel.dde83716.jpg";